import { render, staticRenderFns } from "./c1m1MoreActions.vue?vue&type=template&id=23015809"
import script from "./c1m1MoreActions.vue?vue&type=script&lang=js"
export * from "./c1m1MoreActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports